import axios from 'axios';

export default async (data) => {
  data.tenancy = process.env.VUE_APP_REFERRAL_SITE_TENANCY;
  return axios.post(`${process.env.VUE_APP_API_ENDPOINT}/freshdesk-reporter`, data);
};
